import { connect } from 'react-redux'
import { selectAssignedAgent } from 'selectors/tickets'
import { selectShowMentionSelector } from 'selectors/mentions'
import {
  selectNewCommentIsSendable,
  doInvalidateNoteDraft,
  doUpdateAndLogNewConversation,
  doUpdateNoteDraft,
  doUpdateNoteDraftToRecipientDelayed,
} from 'ducks/drafts'
import LogConvoForm from './view'

const select = state => ({
  assignedAgent: selectAssignedAgent(state),
  showMentionSelector: selectShowMentionSelector(state),
  isDraftSendable: selectNewCommentIsSendable(state),
  ticketId: 'new',
})

const perform = dispatch => ({
  doDeleteDraft: ticketId => dispatch(doInvalidateNoteDraft(ticketId)),
  updateAndSendDraft: (ticketId, prop, val) =>
    dispatch(doUpdateAndLogNewConversation(ticketId, prop, val)),
  updateDraft: (ticketId, prop, val) =>
    dispatch(doUpdateNoteDraft(ticketId, prop, val)),
  updateRecipientDelayed: (ticketId, recipient) =>
    dispatch(doUpdateNoteDraftToRecipientDelayed(ticketId, recipient)),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export default connect(select, perform, mergeProps)(LogConvoForm)
